import { GovernmentPortalWorkPage } from "@/components/non_registrant/government-portal-pages";
import { createFileRoute } from "@tanstack/react-router";

const validateWorkSearch = (search: Record<string, unknown>) => ({
  licenseId: (search.licenseId as string) || undefined,
});

export const Route = createFileRoute("/government/registrations")({
  validateSearch: validateWorkSearch,
  component: GovernmentPortalWorkPage,
});
